import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    width: '100%',
    backgroundColor: colors.newUI.therapist.primaryBlue10,
  },
  innerBodyWrapper: {
    width: 700,
    marginRight: 'auto',
    marginLeft: 'auto',
    paddingVertical: 32,
  },
});
